import React, {useState, useRef} from 'react';
import {Alert, Radio, RadioGroup} from 'rsuite';
import Modal from '../../../components/Modal';
import FormRandom from "./FormRandom";
import FormTemplateList from "./FormTemplateList";
import FormNumbersList from "./FormNumbersList";
import {
    PRICE_RANGE_GENERATE_BY_SDE_API,
    PRICE_RANGE_GENERATE_BY_TEMPLATE_API,
    PRICE_RANGE_GENERATE_BY_NUMBER_LIST_API
} from "../../../const/apiMethods";
import {api} from "../../../api/loginRoutes";
import {Spacer} from "../../../components/base/Spacer";
import ModalNewRangeResult from "./ModalNewRangeResult";
import {responseErrorToString} from "../../../utils";
import {ButtonPrimary} from "../../../components/base/BaseButton";

const formMethods = [
    {id: PRICE_RANGE_GENERATE_BY_TEMPLATE_API, label: "Per Template"},
    {id: PRICE_RANGE_GENERATE_BY_SDE_API, label: "Random"},
    {id: PRICE_RANGE_GENERATE_BY_NUMBER_LIST_API, label: "Numbers"},
];


export default ({sde_key, handleSubmit}) => {
    const [newNumbersCount, setNewNumbersCount] = useState(null);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formMethod, setFormMethod] = useState(PRICE_RANGE_GENERATE_BY_TEMPLATE_API);
    const formRef = useRef(null);
    const [resultDataRejected, setResultDataRejected] = useState([]);
    const [resultData, setResultData] = useState([]);
    const [showResultModal, setShowResultModal] = useState(false);


    React.useEffect(() => {
        setFormMethod(!!sde_key ? PRICE_RANGE_GENERATE_BY_SDE_API : PRICE_RANGE_GENERATE_BY_TEMPLATE_API);
    }, [sde_key]);


    const onSubmit = () => {
        if ( !formRef.current.check() )
            return;

        setLoading(true);

        const value = {...formRef.current.getFormValue()};

        if (value.template_list) {
            value.template_list = value.template_list
                .replace(/\r?\n/g, ' ').split(' ').filter(s => s !== '');
        }
        if (value.number_list) {
            value.number_list = value.number_list
                .replace(/\r?\n/g, ' ').split(' ').filter(s => s !== '');
        }
        if (value.ranges) {
            value.ranges = +value.ranges;
        }

        api(formMethod, value)
            .then(response => {
                setLoading(false);

                if (!response)
                    return;

                if (response.reason_code) {
                    Alert.error(responseErrorToString(response));
                    return;
                }

                if (formMethod === PRICE_RANGE_GENERATE_BY_NUMBER_LIST_API) {
                    setShowResultModal(true);
                    setNewNumbersCount(response.new_numbers_count);
                    setResultDataRejected(response.rejected_numbers);
                    setResultData(response.price_range_list);
                    setShow(false);
                    return;
                }

                Alert.success(`Generated ${response.ranges || 0} ranges`);
                setShow(false);

                if (handleSubmit) {
                    handleSubmit(response);
                }
            })
    };

    return (
        <>
            <ButtonPrimary
                onClick={() => setShow(true)}
            >
                + Add ranges
            </ButtonPrimary>

            <Modal
                show={show}
                successText="Create"
                width={600}
                footer={true}
                disabled={loading}
                title="Add new ranges"
                onSuccess={onSubmit}
                onClose={() => {
                    setShow(false);
                }}
            >
                <RadioGroup value={formMethod} onChange={setFormMethod} inline>
                    {formMethods.map(item => (
                        <Radio value={item.id}>{item.label}</Radio>
                    ))}
                </RadioGroup>
                <Spacer size={24}/>

                {formMethod === PRICE_RANGE_GENERATE_BY_SDE_API &&
                    <FormRandom sde_key={sde_key} ref={formRef} />
                }
                {formMethod === PRICE_RANGE_GENERATE_BY_TEMPLATE_API &&
                    <FormTemplateList ref={formRef} />
                }
                {formMethod === PRICE_RANGE_GENERATE_BY_NUMBER_LIST_API &&
                    <FormNumbersList ref={formRef} />
                }
            </Modal>

            <ModalNewRangeResult
                newNumbersCount={newNumbersCount}
                show={showResultModal}
                data={resultData}
                rejectedNumbers={resultDataRejected}
                onClose={() => setShowResultModal(false)}
            />

        </>
    );
};